import { expose } from '@/rpc';
import { ref } from 'vue'

// there should the host viewport size be stored
const _hostwidth = document.body.getAttribute('data-width')
const _hostheight = document.body.getAttribute('data-height')
// if not set, we use the full size
const _width = _hostwidth ? Number.parseInt(_hostwidth, 10) : Number.MAX_SAFE_INTEGER
const _height = _hostheight ? Number.parseInt(_hostheight, 10) : Number.MAX_SAFE_INTEGER

export function useWatchViewportSize() {
  // we also have to check if the values are valid
  const width = Number.isNaN(_width) ? Number.MAX_SAFE_INTEGER : _width;
  const height = Number.isNaN(_height) ? Number.MAX_SAFE_INTEGER : _height;

  const viewport = ref({
    width,
    height
  });

  expose('resize', (data: { width: number, height: number }) => {
    viewport.value.width = data.width;
    viewport.value.height = data.height;
  });

  return { viewport }
}
